import axios from "axios";
import api from "../api";
const servicesService = {
  // Get all services
  getAllServices: async () => {
    try {
      const response = await api.get("/services");
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error);
      // Return mock data as fallback
      return {
        data: servicesService.getMockServicesData(),
        success: true,
      };
    }
  },

  // Create a new service
  createService: async (serviceData) => {
    try {
      const response = await api.post("/services", serviceData);
      return response.data;
    } catch (error) {
      console.error("Error creating service:", error);
      throw error;
    }
  },

  // Delete a service
  deleteService: async (serviceId) => {
    try {
      const response = await api.delete(`/services/${serviceId}/destroy`);
      return response.data;
    } catch (error) {
      console.error("Error deleting service:", error);
      throw error;
    }
  },

  // Update service name
  updateServiceName: async (serviceId, name) => {
    try {
      const response = await api.put(`/services/${serviceId}/name`, { name });
      return response.data;
    } catch (error) {
      console.error("Error updating service name:", error);
      throw error;
    }
  },

  // Update service visibility
  updateServiceVisibility: async (serviceId, visible) => {
    try {
      const response = await api.post("/services/visibility", {
        id: serviceId,
        value: visible,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating service visibility:", error);
      throw error;
    }
  },

  // Mock data for development/testing
  getMockServicesData: () => {
    return [
      {
        id: 1,
        name: "Cleaning Service",
        visible_to_guardians: true,
        created_at: "2024-01-15T10:00:00Z",
        updated_at: "2024-01-15T10:00:00Z",
      },
      {
        id: 2,
        name: "Maintenance Service",
        visible_to_guardians: true,
        created_at: "2024-01-14T09:00:00Z",
        updated_at: "2024-01-14T09:00:00Z",
      },
      {
        id: 3,
        name: "Security Service",
        visible_to_guardians: false,
        created_at: "2024-01-13T08:00:00Z",
        updated_at: "2024-01-13T08:00:00Z",
      },
      {
        id: 4,
        name: "Gardening Service",
        visible_to_guardians: true,
        created_at: "2024-01-12T07:00:00Z",
        updated_at: "2024-01-12T07:00:00Z",
      },
      {
        id: 5,
        name: "Plumbing Service",
        visible_to_guardians: true,
        created_at: "2024-01-11T06:00:00Z",
        updated_at: "2024-01-11T06:00:00Z",
      },
      {
        id: 6,
        name: "Electrical Service",
        visible_to_guardians: true,
        created_at: "2024-01-10T05:00:00Z",
        updated_at: "2024-01-10T05:00:00Z",
      },
      {
        id: 7,
        name: "HVAC Service",
        visible_to_guardians: false,
        created_at: "2024-01-09T04:00:00Z",
        updated_at: "2024-01-09T04:00:00Z",
      },
      {
        id: 8,
        name: "Pest Control Service",
        visible_to_guardians: true,
        created_at: "2024-01-08T03:00:00Z",
        updated_at: "2024-01-08T03:00:00Z",
      },
      {
        id: 9,
        name: "Waste Management Service",
        visible_to_guardians: true,
        created_at: "2024-01-07T02:00:00Z",
        updated_at: "2024-01-07T02:00:00Z",
      },
      {
        id: 10,
        name: "Internet Service",
        visible_to_guardians: false,
        created_at: "2024-01-06T01:00:00Z",
        updated_at: "2024-01-06T01:00:00Z",
      },
    ];
  },
};

export default servicesService;
